import React from "react";
import { PRODUCT_COLLECTION_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import MenuNavList from "components/FormerEditor/MenuNavList";

const Hub = (props) => {
  const MENU_ITEMS_CONFIG = [
    {
      label: "Products",
      focus: [
        {
          key: STATE_KEYS.EDITOR.MENU_INTENT,
          value: PRODUCT_COLLECTION_INTENT.PRODUCT_ORDER
        },
        {
          key: STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT,
          value: null
        }
      ]
    },
    {
      label: "Checkout",
      focus: [
        {
          key: STATE_KEYS.EDITOR.MENU_INTENT,
          value: PRODUCT_COLLECTION_INTENT.CHECKOUT_SETTINGS
        }
      ]
    },
    {
      label: "Presentation",
      focus: [
        {
          key: STATE_KEYS.EDITOR.MENU_INTENT,
          value: PRODUCT_COLLECTION_INTENT.PRESENTATION_SETTINGS
        }
      ]
    }
  ];

  return <MenuNavList config={MENU_ITEMS_CONFIG} />;
};

export default Hub;
